var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap"},[_c('el-pagination',{ref:"pagination",attrs:{"hide-on-single-page":false,"pager-count":5,"page-size":_vm.paging.limit,"total":_vm.paging.total,"current-page":_vm.currentPage,"background":"","layout":_vm.layout},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }